import ColombiaFlag from '../assets/images/country/colombia.png';
import MexicoFlag from '../assets/images/country/mexico.png';
import UsFlag from '../assets/images/country/us.png';
import CanadaFlag from '../assets/images/country/canada.png';
import EuropeFlag from '../assets/images/country/europe.png';
import BrazilFlag from '../assets/images/country/brazil.png';
import ChinaFlag from '../assets/images/country/china.png';
import KoreaFlag from '../assets/images/country/korea.png';
import PhilippineFlag from '../assets/images/country/philippine.png';
import IndiaFlag from '../assets/images/country/india.png';
import IndonesiaFlag from '../assets/images/country/indonesia.png';
import MalasiaFlag from '../assets/images/country/malasia.png';
import SingaporeFlag from '../assets/images/country/singapore.png';
import ThailandFlag from '../assets/images/country/thailand.png';
import VietnamFlag from '../assets/images/country/vietnam.png';

import Solana from '../assets/images/blockchain/solana.png';
import Polygon from '../assets/images/blockchain/polygon.png';

export const countryData = [
  {
    flag: ColombiaFlag,
    areaCode: '+57',
    country: 'Colombia',
    isoCode3: 'COL',
  },
  {
    flag: MexicoFlag,
    areaCode: '+52',
    country: 'Mexico',
    isoCode3: 'MEX',
  },
  {
    flag: UsFlag,
    areaCode: '+1',
    country: 'Usa',
    isoCode3: 'USA',
  },
  {
    flag: CanadaFlag,
    areaCode: '+1',
    country: 'Canada',
    isoCode3: 'CAN',
  },
  {
    flag: EuropeFlag,
    areaCode: '+3',
    country: 'Europe',
    isoCode3: 'EUR', // Not an official ISO code — use with caution.
  },
  {
    flag: ChinaFlag,
    areaCode: '+86',
    country: 'China',
    isoCode3: 'CHN',
  },
  {
    flag: KoreaFlag,
    areaCode: '+82',
    country: 'Korea',
    isoCode3: 'KOR',
  },
  {
    flag: PhilippineFlag,
    areaCode: '+63',
    country: 'Philippine',
    isoCode3: 'PHL',
  },
  {
    flag: IndiaFlag,
    areaCode: '+91',
    country: 'India',
    isoCode3: 'IND',
  },
  {
    flag: IndonesiaFlag,
    areaCode: '+62',
    country: 'Indonesia',
    isoCode3: 'IDN',
  },
  {
    flag: MalasiaFlag,
    areaCode: '+60',
    country: 'Malasia',
    isoCode3: 'MYS',
  },
  {
    flag: SingaporeFlag,
    areaCode: '+65',
    country: 'Singapore',
    isoCode3: 'SGP',
  },
  {
    flag: ThailandFlag,
    areaCode: '+66',
    country: 'Thailand',
    isoCode3: 'THA',
  },
  {
    flag: VietnamFlag,
    areaCode: '+84',
    country: 'Vietnam',
    isoCode3: 'VNM',
  },
];

export const Roles = [
  {
    key: 'individual',
    value: 'Persona',
  },
  {
    key: 'business',
    value: 'Empresa',
  },
];

export const IDType = [
  {
    key: 'CC',
    value: 'Cédula de Ciudadanía',
  },
  {
    key: 'CE',
    value: 'Cédula de Extranjería',
  },
  {
    key: 'PS',
    value: 'Pasaporte',
  },
  {
    key: 'NIT',
    value: 'Número de Identificación Tributaria',
  },
];

export const WalletType = [
  {
    key: 'savings',
    value: 'Cuenta de ahorros',
  },
  {
    key: 'checking',
    value: 'Cuenta Corriente',
  },
];

export const EuropeRegion = [
  { key: 'ALB', value: 'Albania' },
  { key: 'DEU', value: 'Alemania' },
  { key: 'AND', value: 'Andorra' },
  { key: 'ARM', value: 'Armenia' },
  { key: 'AUT', value: 'Austria' },
  { key: 'AZE', value: 'Azerbaiyán' },
  { key: 'BEL', value: 'Bélgica' },
  { key: 'BLR', value: 'Bielorrusia' },
  { key: 'BIH', value: 'Bosnia y Herzegovina' },
  { key: 'BGR', value: 'Bulgaria' },
  { key: 'VAT', value: 'Ciudad del Vaticano' },
  { key: 'HRV', value: 'Croacia' },
  { key: 'CYP', value: 'Chipre' },
  { key: 'DNK', value: 'Dinamarca' },
  { key: 'SVK', value: 'Eslovaquia' },
  { key: 'SVN', value: 'Eslovenia' },
  { key: 'ESP', value: 'España' },
  { key: 'EST', value: 'Estonia' },
  { key: 'FIN', value: 'Finlandia' },
  { key: 'FRA', value: 'Francia' },
  { key: 'GEO', value: 'Georgia' },
  { key: 'GRC', value: 'Grecia' },
  { key: 'HUN', value: 'Hungría' },
  { key: 'IRL', value: 'Irlanda' },
  { key: 'ISL', value: 'Islandia' },
  { key: 'ITA', value: 'Italia' },
  { key: 'KAZ', value: 'Kazajistán' },
  { key: 'XKX', value: 'Kosovo' },
  { key: 'LVA', value: 'Letonia' },
  { key: 'LIE', value: 'Liechtenstein' },
  { key: 'LTU', value: 'Lituania' },
  { key: 'LUX', value: 'Luxemburgo' },
  { key: 'MKD', value: 'Macedonia del Norte' },
  { key: 'MLT', value: 'Malta' },
  { key: 'MDA', value: 'Moldavia' },
  { key: 'MCO', value: 'Mónaco' },
  { key: 'MNE', value: 'Montenegro' },
  { key: 'NOR', value: 'Noruega' },
  { key: 'NLD', value: 'Países Bajos' },
  { key: 'POL', value: 'Polonia' },
  { key: 'PRT', value: 'Portugal' },
  { key: 'GBR', value: 'Reino Unido' },
  { key: 'CZE', value: 'República Checa' },
  { key: 'ROU', value: 'Rumanía' },
  { key: 'RUS', value: 'Rusia' },
  { key: 'SMR', value: 'San Marino' },
  { key: 'SRB', value: 'Serbia' },
  { key: 'SWE', value: 'Suecia' },
  { key: 'CHE', value: 'Suiza' },
  { key: 'TUR', value: 'Turquía' },
  { key: 'UKR', value: 'Ucrania' },
];

export const VirtualAccountCurrencies = [
  {
    flag: UsFlag,
    currency: 'usd',
    text: 'Cuenta virtual Flowex USA',
  },
  {
    flag: EuropeFlag,
    currency: 'eur',
    text: 'Cuenta virtual Flowex Europa',
  },
  {
    flag: MexicoFlag,
    currency: 'mxn',
    text: 'Cuenta virtual Flowex México',
  },
  {
    flag: BrazilFlag,
    currency: 'brl',
    text: 'Cuenta virtual Flowex Brasil',
  },
];

export const ColombiaBanksTempData = [
  { key: 'ALLIANZ', value: 'ALLIANZ' },
  { key: 'ALMACENES EXITO', value: 'ALMACENES EXITO' },
  { key: 'ALPINA', value: 'ALPINA' },
  { key: 'AV VILLAS', value: 'AV VILLAS' },
  { key: 'BANCAMIA', value: 'BANCAMIA' },
  { key: 'BANCO AGRARIO', value: 'BANCO AGRARIO' },
  { key: 'BANCO BTG PACTUAL', value: 'BANCO BTG PACTUAL' },
  { key: 'BANCO CAJA SOCIAL', value: 'BANCO CAJA SOCIAL' },
  { key: 'BANCO COOPERATIVO COOPCENTRAL', value: 'BANCO COOPERATIVO COOPCENTRAL' },
  { key: 'BANCO CREDIFINANCIERA', value: 'BANCO CREDIFINANCIERA' },
  { key: 'BANCO DE BOGOTA', value: 'BANCO DE BOGOTA' },
  { key: 'BANCO DE COMERCIO EXTERIOR', value: 'BANCO DE COMERCIO EXTERIOR' },
  { key: 'BANCO DE LA REPUBLICA', value: 'BANCO DE LA REPUBLICA' },
  { key: 'BANCO DE OCCIDENTE', value: 'BANCO DE OCCIDENTE' },
  { key: 'BANCO FALABELLA', value: 'BANCO FALABELLA' },
  { key: 'BANCO FINANDINA', value: 'BANCO FINANDINA' },
  { key: 'BANCO J.P. MORGAN COLOMBIA', value: 'BANCO J.P. MORGAN COLOMBIA' },
  { key: 'BANCO MULTIBANK', value: 'BANCO MULTIBANK' },
  { key: 'BANCO MUNDO MUJER', value: 'BANCO MUNDO MUJER' },
  { key: 'BANCO PICHINCHA', value: 'BANCO PICHINCHA' },
  { key: 'BANCO POPULAR', value: 'BANCO POPULAR' },
  { key: 'BANCO SANTANDER DE NEGOCIOS', value: 'BANCO SANTANDER DE NEGOCIOS' },
  { key: 'BANCO SERFINANZA', value: 'BANCO SERFINANZA' },
  { key: 'BANCO W', value: 'BANCO W' },
  { key: 'BANCO_GNB_SUDAMERIS', value: 'BANCO_GNB_SUDAMERIS' },
  { key: 'BANCOLDEX', value: 'BANCOLDEX' },
  { key: 'BANCOLOMBIA', value: 'BANCOLOMBIA' },
  { key: 'BANCOOMEVA', value: 'BANCOOMEVA' },
  { key: 'BBVA', value: 'BBVA' },
  {
    key: 'BBVA ASSET MANAGEMENT SOCIEDAD FIDUCIARIA',
    value: 'BBVA ASSET MANAGEMENT SOCIEDAD FIDUCIARIA',
  },
  { key: 'BNP PARIBAS COLOMBIA', value: 'BNP PARIBAS COLOMBIA' },
  { key: 'BTG PACTUAL', value: 'BTG PACTUAL' },
  {
    key: 'CAMARA DE COMPENSACION DE DIVISAS DE COLOMBIA',
    value: 'CAMARA DE COMPENSACION DE DIVISAS DE COLOMBIA',
  },
  { key: 'CARVAJAL SERVICIOS', value: 'CARVAJAL SERVICIOS' },
  { key: 'CENIT', value: 'CENIT' },
  { key: 'CITIBANK', value: 'CITIBANK' },
  { key: 'COLSUBSIDIO', value: 'COLSUBSIDIO' },
  { key: 'COLTEFINANCIERA', value: 'COLTEFINANCIERA' },
  { key: 'COMPENSAR', value: 'COMPENSAR' },
  { key: 'CONFIAR', value: 'CONFIAR' },
  { key: 'COOFINEP', value: 'COOFINEP' },
  { key: 'COOPERATIVA FINANCIERA DE ANTIOQUIA', value: 'COOPERATIVA FINANCIERA DE ANTIOQUIA' },
  { key: 'COOTRAFA', value: 'COOTRAFA' },
  { key: 'CORPORACION FINANCIERA DEL VALLE', value: 'CORPORACION FINANCIERA DEL VALLE' },
  { key: 'CORREDORES DAVIVIENDA', value: 'CORREDORES DAVIVIENDA' },
  { key: 'COTRAFA COOPERATIVA FINANCIERA', value: 'COTRAFA COOPERATIVA FINANCIERA' },
  { key: 'CREDICORP CAPITAL COLOMBIA', value: 'CREDICORP CAPITAL COLOMBIA' },
  { key: 'CREDICORP_CAPITAL_COLOMBIA', value: 'CREDICORP_CAPITAL_COLOMBIA' },
  { key: 'DAVIPLATA', value: 'DAVIPLATA' },
  { key: 'DAVIVIENDA', value: 'DAVIVIENDA' },
  { key: 'DECEVAL', value: 'DECEVAL' },
  { key: 'DGCPTN', value: 'DGCPTN' },
  { key: 'DGCPTN SISTEMA GENERAL DE REGAIFAS', value: 'DGCPTN SISTEMA GENERAL DE REGAIFAS' },
  { key: 'ECOFERTIL', value: 'ECOFERTIL' },
  { key: 'ECOPETROL', value: 'ECOPETROL' },
  {
    key: 'EMPRESA DE TELECOMUNICACIONES DE BOGOTA',
    value: 'EMPRESA DE TELECOMUNICACIONES DE BOGOTA',
  },
  { key: 'ENLACE OPERATIVO', value: 'ENLACE OPERATIVO' },
  { key: 'FEDECAJAS', value: 'FEDECAJAS' },
  { key: 'FIDUCIARIA BANCOLOMBIA', value: 'FIDUCIARIA BANCOLOMBIA' },
  { key: 'FIDUCIARIA BOGOTA', value: 'FIDUCIARIA BOGOTA' },
  { key: 'FIDUCIARIA CORFICOLOMBIANA', value: 'FIDUCIARIA CORFICOLOMBIANA' },
  { key: 'FIDUCIARIA DE OCCIDENTE', value: 'FIDUCIARIA DE OCCIDENTE' },
  { key: 'FINANCIERA DE DESARROLLO NACIONAL', value: 'FINANCIERA DE DESARROLLO NACIONAL' },
  {
    key: 'FONDO DE GARANTIAS DE INSTITUCIONES FINANCIERAS',
    value: 'FONDO DE GARANTIAS DE INSTITUCIONES FINANCIERAS',
  },
  { key: 'FONDO LATINOAMERICANO DE RESERVAS', value: 'FONDO LATINOAMERICANO DE RESERVAS' },
  {
    key: 'FONDO VOLUNTARIO DE PENSIONES ALLIANZ SEGUROS',
    value: 'FONDO VOLUNTARIO DE PENSIONES ALLIANZ SEGUROS',
  },
  { key: 'GESTION Y CONTACTO', value: 'GESTION Y CONTACTO' },
  { key: 'GIROS Y FINANZAS CF', value: 'GIROS Y FINANZAS CF' },
  { key: 'GIROS Y FINANZAS CFC', value: 'GIROS Y FINANZAS CFC' },
  { key: 'HOCOL', value: 'HOCOL' },
  { key: 'IRIS', value: 'IRIS' },
  { key: 'ISAGEN', value: 'ISAGEN' },
  { key: 'ITAU', value: 'ITAU' },
  { key: 'JURISCOOP', value: 'JURISCOOP' },
  { key: 'LULO BANK', value: 'LULO BANK' },
  { key: 'MAPFRE SEGUROS GENERALES', value: 'MAPFRE SEGUROS GENERALES' },
  { key: 'MIBANCO', value: 'MIBANCO' },
  { key: 'MONOMEROS COLOMBO VENEZOLANOS', value: 'MONOMEROS COLOMBO VENEZOLANOS' },
  { key: 'MOVII', value: 'MOVII' },
  { key: 'MUNICIPIO DE MEDELLIN', value: 'MUNICIPIO DE MEDELLIN' },
  { key: 'MUNICIPIO SANTIAGO DE CALI', value: 'MUNICIPIO SANTIAGO DE CALI' },
  { key: 'NEQUI', value: 'NEQUI' },
  { key: 'OLEODUCTO BICENTENARIO', value: 'OLEODUCTO BICENTENARIO' },
  { key: 'OLEODUCTO CENTRAL', value: 'OLEODUCTO CENTRAL' },
  { key: 'OLEODUCTO_DE_LOS_LLANOS_ORIENTALES', value: 'OLEODUCTO_DE_LOS_LLANOS_ORIENTALES' },
  { key: 'POLIPROPILENO DEL CARIBE', value: 'POLIPROPILENO DEL CARIBE' },
  { key: 'PORVENIR', value: 'PORVENIR' },
  { key: 'RAPPIPAY', value: 'RAPPIPAY' },
  { key: 'REFINERIA DE CARTAGENA', value: 'REFINERIA DE CARTAGENA' },
  { key: 'SCOTIABANK COLPATRIA', value: 'SCOTIABANK COLPATRIA' },
  { key: 'UALA', value: 'UALA' },
  { key: 'UNE EPM TELECOMUNICACIONES', value: 'UNE EPM TELECOMUNICACIONES' },
  { key: 'VALORES BANCOLOMBIA', value: 'VALORES BANCOLOMBIA' },
];
export const ColombiaBanks = [
  // { name: "ALLIANZ", image: "allianz.png" },
  // { name: "ALMACENES EXITO", image: "almacenes_exito.png" },
  // { name: "ALPINA", image: "alpina.png" },
  { name: 'AV VILLAS', image: '/src/assets/images/banks/colombia/av_villas.png' },
  { name: 'BANCAMIA', image: '/src/assets/images/banks/colombia/bancamia.jpeg' },
  { name: 'BANCO AGRARIO', image: '/src/assets/images/banks/colombia/banco_agrario.png' },
  // { name: "BANCO BTG PACTUAL", image: "/src/assets/images/banks/colombia/banco_btg_pactual.png" },
  { name: 'BANCO CAJA SOCIAL', image: '/src/assets/images/banks/colombia/banco_caja_social.png' },
  {
    name: 'BANCO COOPERATIVO COOPCENTRAL',
    image: '/src/assets/images/banks/colombia/banco_cooperativo_coopcentral.jpeg',
  },
  {
    name: 'BANCO CREDIFINANCIERA',
    image: '/src/assets/images/banks/colombia/banco_credifinanciera.png',
  },
  { name: 'BANCO DE BOGOTA', image: '/src/assets/images/banks/colombia/banco_de_bogota.jpeg' },
  // { name: "BANCO DE COMERCIO EXTERIOR", image: "/src/assets/images/banks/colombia/banco_de_comercio_exterior.png" },
  // { name: "BANCO DE LA REPUBLICA", image: "/src/assets/images/banks/colombia/banco_de_la_republica.png" },
  { name: 'BANCO DE OCCIDENTE', image: '/src/assets/images/banks/colombia/banco_de_occidente.png' },
  { name: 'BANCO FALABELLA', image: '/src/assets/images/banks/colombia/banco_falabella.jpeg' },
  { name: 'BANCO FINANDINA', image: '/src/assets/images/banks/colombia/banco_finandina.png' },
  // { name: "BANCO J.P. MORGAN COLOMBIA", image: "/src/assets/images/banks/colombia/banco_jp_morgan_colombia.png" },
  // { name: "BANCO MULTIBANK", image: "/src/assets/images/banks/colombia/banco_multibank.png" },
  // { name: "BANCO MUNDO MUJER", image: "/src/assets/images/banks/colombia/banco_mundo_mujer.png" },
  { name: 'BANCO PICHINCHA', image: '/src/assets/images/banks/colombia/banco_pichincha.jpeg' },
  { name: 'BANCO POPULAR', image: '/src/assets/images/banks/colombia/banco_popular.png' },
  // { name: "BANCO SANTANDER DE NEGOCIOS", image: "/src/assets/images/banks/colombia/banco_santander_de_negocios.png" },
  // { name: "BANCO SERFINANZA", image: "/src/assets/images/banks/colombia/banco_serfinanza.png" },
  { name: 'BANCO W', image: '/src/assets/images/banks/colombia/banco_w.png' },
  {
    name: 'BANCO_GNB_SUDAMERIS',
    image: '/src/assets/images/banks/colombia/banco_gnb_sudameris.png',
  },
  // { name: "BANCOLDEX", image: "/src/assets/images/banks/colombia/bancoldex.png" },
  { name: 'BANCOLOMBIA', image: '/src/assets/images/banks/colombia/bancolombia.png' },
  { name: 'BANCOOMEVA', image: '/src/assets/images/banks/colombia/bancoomeva.png' },
  { name: 'BBVA', image: '/src/assets/images/banks/colombia/bbva.jpeg' },
  // { name: "BBVA ASSET MANAGEMENT SOCIEDAD FIDUCIARIA", image: "/src/assets/images/banks/colombia/bbva_asset_management_sociedad_fiduciaria.png" },
  // { name: "BNP PARIBAS COLOMBIA", image: "/src/assets/images/banks/colombia/bnp_paribas_colombia.png" },
  // { name: "BTG PACTUAL", image: "/src/assets/images/banks/colombia/btg_pactual.png" },
  // { name: "CAMARA DE COMPENSACION DE DIVISAS DE COLOMBIA", image: "/src/assets/images/banks/colombia/camara_de_compensacion_de_divisas_de_colombia.png" },
  // { name: "CARVAJAL SERVICIOS", image: "/src/assets/images/banks/colombia/carvajal_servicios.png" },
  // { name: "CENIT", image: "/src/assets/images/banks/colombia/cenit.png" },
  // { name: "CITIBANK", image: "/src/assets/images/banks/colombia/citibank.png" },
  // { name: "COLSUBSIDIO", image: "/src/assets/images/banks/colombia/colsubsidio.png" },
  // { name: "COLTEFINANCIERA", image: "/src/assets/images/banks/colombia/coltefinanciera.png" },
  // { name: "COMPENSAR", image: "/src/assets/images/banks/colombia/compensar.png" },
  // { name: "CONFIAR", image: "/src/assets/images/banks/colombia/confiar.png" },
  // { name: "COOFINEP", image: "/src/assets/images/banks/colombia/coofinep.png" },
  // { name: "COOPERATIVA FINANCIERA DE ANTIOQUIA", image: "/src/assets/images/banks/colombia/cooperativa_financiera_de_antioquia.png" },
  // { name: "COOTRAFA", image: "/src/assets/images/banks/colombia/cootrafa.png" },
  // { name: "CORPORACION FINANCIERA DEL VALLE", image: "/src/assets/images/banks/colombia/corporacion_financiera_del_valle.png" },
  // { name: "CORREDORES DAVIVIENDA", image: "/src/assets/images/banks/colombia/corredores_davivienda.png" },
  // { name: "COTRAFA COOPERATIVA FINANCIERA", image: "/src/assets/images/banks/colombia/cotrafa_cooperativa_financiera.png" },
  // { name: "CREDICORP CAPITAL COLOMBIA", image: "/src/assets/images/banks/colombia/credicorp_capital_colombia.png" },
  // { name: "CREDICORP_CAPITAL_COLOMBIA", image: "/src/assets/images/banks/colombia/credicorp_capital_colombia.png" },
  { name: 'DAVIPLATA', image: '/src/assets/images/banks/colombia/daviplata.png' },
  { name: 'DAVIVIENDA', image: '/src/assets/images/banks/colombia/davivienda.jpeg' },
  // { name: "DECEVAL", image: "/src/assets/images/banks/colombia/deceval.png" },
  // { name: "DGCPTN", image: "/src/assets/images/banks/colombia/dgcptn.png" },
  // { name: "DGCPTN SISTEMA GENERAL DE REGAIFAS", image: "/src/assets/images/banks/colombia/dgcptn_sistema_general_de_regaifas.png" },
  // { name: "ECOFERTIL", image: "/src/assets/images/banks/colombia/ecofertil.png" },
  // { name: "ECOPETROL", image: "/src/assets/images/banks/colombia/ecopetrol.png" },
  // { name: "EMPRESA DE TELECOMUNICACIONES DE BOGOTA", image: "/src/assets/images/banks/colombia/empresa_de_telecomunicaciones_de_bogota.png" },
  // { name: "ENLACE OPERATIVO", image: "/src/assets/images/banks/colombia/enlace_operativo.png" },
  // { name: "FEDECAJAS", image: "/src/assets/images/banks/colombia/fedecajas.png" },
  // { name: "FIDUCIARIA BANCOLOMBIA", image: "/src/assets/images/banks/colombia/fiduciaria_bancolombia.png" },
  // { name: "FIDUCIARIA BOGOTA", image: "/src/assets/images/banks/colombia/fiduciaria_bogota.png" },
  // { name: "FIDUCIARIA CORFICOLOMBIANA", image: "/src/assets/images/banks/colombia/fiduciaria_corficolombiana.png" },
  // { name: "FIDUCIARIA DE OCCIDENTE", image: "/src/assets/images/banks/colombia/fiduciaria_de_occidente.png" },
  // { name: "FINANCIERA DE DESARROLLO NACIONAL", image: "/src/assets/images/banks/colombia/financiera_de_desarrollo_nacional.png" },
  // { name: "FONDO DE GARANTIAS DE INSTITUCIONES FINANCIERAS", image: "/src/assets/images/banks/colombia/fondo_de_garantias_de_instituciones_financieras.png" },
  // { name: "FONDO LATINOAMERICANO DE RESERVAS", image: "/src/assets/images/banks/colombia/fondo_latinoamericano_de_reservas.png" },
  // { name: "FONDO VOLUNTARIO DE PENSIONES ALLIANZ SEGUROS", image: "/src/assets/images/banks/colombia/fondo_voluntario_de_pensiones_allianz_seguros.png" },
  // { name: "GESTION Y CONTACTO", image: "/src/assets/images/banks/colombia/gestion_y_contacto.png" },
  // { name: "GIROS Y FINANZAS CF", image: "/src/assets/images/banks/colombia/giros_y_finanzas_cf.png" },
  // { name: "GIROS Y FINANZAS CFC", image: "/src/assets/images/banks/colombia/giros_y_finanzas_cfc.png" },
  // { name: "HOCOL", image: "/src/assets/images/banks/colombia/hocol.png" },
  // { name: "IRIS", image: "/src/assets/images/banks/colombia/iris.png" },
  // { name: "ISAGEN", image: "/src/assets/images/banks/colombia/isagen.png" },
  { name: 'ITAU', image: '/src/assets/images/banks/colombia/itau.png' },
  // { name: "JURISCOOP", image: "/src/assets/images/banks/colombia/juriscoop.png" },
  // { name: "LULO BANK", image: "/src/assets/images/banks/colombia/lulo_bank.png" },
  // { name: "MAPFRE SEGUROS GENERALES", image: "/src/assets/images/banks/colombia/mapfre_seguros_generales.png" },
  // { name: "MIBANCO", image: "/src/assets/images/banks/colombia/mibanco.png" },
  // { name: "MONOMEROS COLOMBO VENEZOLANOS", image: "/src/assets/images/banks/colombia/monomeros_colombo_venezolanos.png" },
  // { name: "MOVII", image: "/src/assets/images/banks/colombia/movii.png" },
  // { name: "MUNICIPIO DE MEDELLIN", image: "/src/assets/images/banks/colombia/municipio_de_medellin.png" },
  // { name: "MUNICIPIO SANTIAGO DE CALI", image: "/src/assets/images/banks/colombia/municipio_santiago_de_cali.png" },
  { name: 'NEQUI', image: '/src/assets/images/banks/colombia/nequi.jpeg' },
  // { name: "OLEODUCTO BICENTENARIO", image: "/src/assets/images/banks/colombia/oleoducto_bicentenario.png" },
  // { name: "OLEODUCTO CENTRAL", image: "/src/assets/images/banks/colombia/oleoducto_central.png" },
  // { name: "OLEODUCTO_DE_LOS_LLANOS_ORIENTALES", image: "/src/assets/images/banks/colombia/oleoducto_de_los_llanos_orientales.png" },
  // { name: "POLIPROPILENO DEL CARIBE", image: "/src/assets/images/banks/colombia/polipropileno_del_caribe.png" },
  // { name: "PORVENIR", image: "/src/assets/images/banks/colombia/porvenir.png" },
  // { name: "RAPPIPAY", image: "/src/assets/images/banks/colombia/rappipay.png" },
  // { name: "REFINERIA DE CARTAGENA", image: "/src/assets/images/banks/colombia/refineria_de_cartagena.png" },
  {
    name: 'SCOTIABANK COLPATRIA',
    image: '/src/assets/images/banks/colombia/scotiabank_colpatria.jpeg',
  },
  // { name: "UALA", image: "/src/assets/images/banks/colombia/uala.png" },
  // { name: "UNE EPM TELECOMUNICACIONES", image: "/src/assets/images/banks/colombia/une_epm_telecomunicaciones.png" },
  // { name: "VALORES BANCOLOMBIA", image: "/src/assets/images/banks/colombia/valores_bancolombia.png" }
];
export const UsBanks = [
  { name: 'Ally Bank', image: '/src/assets/images/banks/usa/ally_bank.jpeg' },
  { name: 'Atlantic Union Bank', image: '/src/assets/images/banks/usa/atlantic_union.png' },
  { name: 'Bank of America', image: '/src/assets/images/banks/usa/bank_of_america.png' },
  { name: 'Bank OZK', image: '/src/assets/images/banks/usa/bank_ozk.png' },
  { name: 'Bank of New York Mellon', image: '/src/assets/images/banks/usa/bnymellon.png' },
  { name: 'BB&T (now Truist Bank)', image: '/src/assets/images/banks/usa/truist.png' },
  { name: 'BMO Harris Bank', image: '/src/assets/images/banks/usa/bmo_harris.png' },
  { name: 'Capital One', image: '/src/assets/images/banks/usa/capital_one.png' },
  { name: 'Charles Schwab Bank', image: '/src/assets/images/banks/usa/charles_schwab.png' },
  { name: 'CFG Bank', image: '/src/assets/images/banks/usa/cfg_bank.png' },
  { name: 'Chase (JPMorgan Chase)', image: '/src/assets/images/banks/usa/jpmorgan_chase.png' },
  { name: 'Citibank', image: '/src/assets/images/banks/usa/citibank.png' },
  { name: 'Cross River Bank', image: '/src/assets/images/banks/usa/cross_river.png' },
  { name: 'Discover Bank', image: '/src/assets/images/banks/usa/discover_bank.png' },
  { name: 'Fifth Third Bank', image: '/src/assets/images/banks/usa/fifth_third_bank.png' },
  { name: 'First Citizens Bank', image: '/src/assets/images/banks/usa/first_citizens.png' },
  { name: 'First Horizon Bank', image: '/src/assets/images/banks/usa/first_horizon.png' },
  { name: 'First National Bank', image: '/src/assets/images/banks/usa/first_national_bank.png' },
  { name: 'Frost Bank', image: '/src/assets/images/banks/usa/frost_bank.png' },
  { name: 'Goldman Sachs Bank', image: '/src/assets/images/banks/usa/goldman_sachs.png' },
  { name: 'Huntington National Bank', image: '/src/assets/images/banks/usa/huntington.png' },
  { name: 'KeyBank', image: '/src/assets/images/banks/usa/keybank.png' },
  { name: 'Lead Bank', image: '/src/assets/images/banks/usa/lead_bank.png' },
  { name: 'M&T Bank', image: '/src/assets/images/banks/usa/mt_bank.png' },
  { name: 'Morgan Stanley Private Bank', image: '/src/assets/images/banks/usa/morgan_stanley.png' },
  { name: 'Old National Bank', image: '/src/assets/images/banks/usa/old_national.png' },
  { name: 'PNC Bank', image: '/src/assets/images/banks/usa/pnc_bank.png' },
  { name: 'Regions Bank', image: '/src/assets/images/banks/usa/regions_bank.png' },
  { name: 'State Street', image: '/src/assets/images/banks/usa/state_street.png' },
  { name: 'Synchrony Bank', image: '/src/assets/images/banks/usa/synchrony_bank.png' },
  { name: 'TD Bank', image: '/src/assets/images/banks/usa/td_bank.png' },
  { name: 'Truist Bank', image: '/src/assets/images/banks/usa/truist.png' },
  { name: 'U.S. Bank', image: '/src/assets/images/banks/usa/us_bank.png' },
  {
    name: 'USAA Federal Savings Bank',
    image: '/src/assets/images/banks/usa/usaa_federal_savings_bank.png',
  },
  { name: 'Wells Fargo', image: '/src/assets/images/banks/usa/wells_fargo.png' },
];
export const MexicoBanks = [
  { name: 'Banamex', image: '/src/assets/images/banks/mexico/banamex.png' }, // Formerly Banamex
  { name: 'Banco Actinver', image: '/src/assets/images/banks/mexico/banco_actinver.jpeg' },
  { name: 'Banco Afirme', image: '/src/assets/images/banks/mexico/banco_afirme.jpeg' },
  { name: 'Banco Banorte', image: '/src/assets/images/banks/mexico/banco_banorte.png' },
  { name: 'Banco BASE', image: '/src/assets/images/banks/mexico/banco_base.jpeg' },
  { name: 'Bineo', image: '/src/assets/images/banks/mexico/bineo.png' },
  { name: 'Banco Compartamos', image: '/src/assets/images/banks/mexico/banco_compartamos.png' },
  { name: 'Banco del Bajío', image: '/src/assets/images/banks/mexico/banbajio.jpeg' },
  { name: 'Banco Intercam', image: '/src/assets/images/banks/mexico/banco_intercam.jpeg' },
  { name: 'Banco Monex', image: '/src/assets/images/banks/mexico/banco_monex.jpeg' },
  { name: 'Banco Multiva', image: '/src/assets/images/banks/mexico/banco_multiva.jpeg' },
  {
    name: 'Banco Nacional de Comercio Exterior, S.N.C.',
    image: '/src/assets/images/banks/mexico/bancomext.png',
  },
  { name: 'Banco Santander México', image: '/src/assets/images/banks/mexico/banco_santander.jpeg' },
  { name: 'Banco Ve por Más', image: '/src/assets/images/banks/mexico/banco_ve_por_mas.jpeg' },
  { name: 'Banco Azteca', image: '/src/assets/images/banks/mexico/banco_azteca.png' },
  { name: 'Bancoppel', image: '/src/assets/images/banks/mexico/bancoppel.jpeg' },
  { name: 'BanRegio', image: '/src/assets/images/banks/mexico/banregio.png' },
  { name: 'BBVA México', image: '/src/assets/images/banks/mexico/bbva_mexico.png' },
  { name: 'Inbursa', image: '/src/assets/images/banks/mexico/inbursa.png' },
  { name: 'Invex Banco', image: '/src/assets/images/banks/mexico/invex_banco.jpeg' },
  { name: 'Nu Mexico Financiera S.A', image: '/src/assets/images/banks/mexico/invex_banco.jpeg' },
  { name: 'Scotiabank México', image: '/src/assets/images/banks/mexico/scotiabank_mexico.png' },
];
export const EuropeBanks = [
  { name: 'Banco Sabadell', image: '/src/assets/images/banks/europe/banco_sabadell.png' },
  { name: 'Banco Santander, S.A.', image: '/src/assets/images/banks/europe/banco_santander.png' },
  { name: 'Bankia', image: '/src/assets/images/banks/europe/bankia.png' },
  { name: 'Bankinter', image: '/src/assets/images/banks/europe/bankinter.jpeg' },
  { name: 'Barclays', image: '/src/assets/images/banks/europe/barclays.png' },
  { name: 'BBVA', image: '/src/assets/images/banks/europe/bbva.png' },
  { name: 'BNP Paribas', image: '/src/assets/images/banks/europe/bnp_paribas.jpeg' },
  { name: 'Caixa Bank', image: '/src/assets/images/banks/europe/caixa_bank.png' },
  { name: 'Commerzbank', image: '/src/assets/images/banks/europe/commerzbank.png' },
  { name: 'Credit Agricole', image: '/src/assets/images/banks/europe/credit_agricole.png' },
  { name: 'De Volksbank', image: '/src/assets/images/banks/europe/de_volksbank.jpeg' },
  { name: 'Deutsche Bank', image: '/src/assets/images/banks/europe/deutsche_bank.png' },
  { name: 'DZ Bank', image: '/src/assets/images/banks/europe/dz_bank.png' },
  { name: 'HSBC Bank', image: '/src/assets/images/banks/europe/hsbc_bank.png' },
  { name: 'ING Bank', image: '/src/assets/images/banks/europe/ing_bank.png' },
  { name: 'Intesa Sanpaolo', image: '/src/assets/images/banks/europe/intesa_sanpaolo.png' },
  { name: 'KBC Bank', image: '/src/assets/images/banks/europe/kbc_bank.png' },
  { name: 'La Banque Postale', image: '/src/assets/images/banks/europe/la_banque_postale.png' },
  { name: 'Lloyds Bank', image: '/src/assets/images/banks/europe/lloyds_bank.jpeg' },
  { name: 'NatWest', image: '/src/assets/images/banks/europe/natwest.jpeg' },
  { name: 'Société Générale', image: '/src/assets/images/banks/europe/societe_generale.png' },
  { name: 'Standard Chartered', image: '/src/assets/images/banks/europe/standard_chartered.png' },
  { name: 'UniCredit', image: '/src/assets/images/banks/europe/unicredit.png' },
  { name: 'Berliner Sparkasse', image: '/src/assets/images/banks/europe/unicredit.png' },
];

export const NativeAsset = [
  {
    assetSymbol: 'SOL',
    assetName: 'Solana',
    icon: Solana
  },
  {
    assetSymbol: 'POLYGON',
    assetName: 'Polygon',
    icon: Polygon
  },
];

export const BrazilBanks = [
  { name: 'Banco do Brasil', image: '/src/assets/images/banks/brazil/banco_do_brasil.png' },
  { name: 'Banrisul', image: '/src/assets/images/banks/brazil/banrisul.png' },
  { name: 'Bradesco', image: '/src/assets/images/banks/brazil/bradesco.png' },
  { name: 'BTG Pactual', image: '/src/assets/images/banks/brazil/btg_pactual.png' },
  { name: 'C6 Bank', image: '/src/assets/images/banks/brazil/c6_bank.png' },
  { name: 'Caixa Econômica Federal', image: '/src/assets/images/banks/brazil/caixa_economica.png' },
  { name: 'Citibank', image: '/src/assets/images/banks/brazil/citibank.png' },
  { name: 'Inter', image: '/src/assets/images/banks/brazil/inter.png' },
  { name: 'Itaú Unibanco', image: '/src/assets/images/banks/brazil/itau_unibanco.png' },
  { name: 'Nubank', image: '/src/assets/images/banks/brazil/nubank.png' },
  { name: 'Safra', image: '/src/assets/images/banks/brazil/safra.png' },
  { name: 'Santander Brasil', image: '/src/assets/images/banks/brazil/santander_brasil.png' },
  { name: 'Sicoob', image: '/src/assets/images/banks/brazil/sicoob.png' },
  { name: 'Sicredi', image: '/src/assets/images/banks/brazil/sicredi.png' },
];

export const PixKeyTypes = [
  { key: 'cpf', value: 'CPF' },
  { key: 'cnpj', value: 'CNPJ' },
  { key: 'email', value: 'Email' },
  { key: 'phone', value: 'Teléfono' },
  { key: 'evp', value: 'Clave aleatoria (EVP)' },
];

export const getFlag = (item) => {
  if (item.source_deposit_instructions.currency == 'usd') return UsFlag;
  if (item.source_deposit_instructions.currency == 'eur') return EuropeFlag;
  if (item.source_deposit_instructions.currency == 'brl') return BrazilFlag;
  return MexicoFlag;
};

export const getRouteName = (peso) => {
  if (peso == 'usd') return 'Flowex USA';
  if (peso == 'eur') return 'Flowex Europa';
  if (peso == 'brl') return 'Flowex Brasil';
  else return 'Flowex México';
};

export const getAccountNumber = (item) => {
  if (item.source_deposit_instructions.currency == 'usd')
    return item.source_deposit_instructions.bank_account_number;
  if (item.source_deposit_instructions.currency == 'eur')
    return item.source_deposit_instructions.iban;
  if (item.source_deposit_instructions.currency == 'brl') {
    const br = item.source_deposit_instructions.br_code || '';
    const m = br.match(/0014br\.gov\.bcb\.pix01(\d{2})/);
    if (m) {
      const len = parseInt(m[1], 10);
      const start = br.indexOf(m[0]) + m[0].length;
      return br.substring(start, start + len);
    }
    return item.source_deposit_instructions.pix_key || 'PIX pendiente';
  }
  return 'mxn-1234567890';
};

export const getDescription = (currency) => {
  if (currency == 'usd')
    return 'Utiliza ésta información para recibir pagos en dólares desde bancos en EE.UU. mediante ACH o WIRE.';
  if (currency == 'mxn')
    return 'Usá estos datos para recibir pagos en pesos mexicanos mediante SPEI.';
  if (currency == 'eur')
    return 'Usá estos datos para recibir pagos en euros por SEPA (Europa) o por SWIFT desde el resto del mundo.';
  if (currency == 'brl')
    return 'Usá estos datos para recibir pagos en reales desde Brasil mediante PIX (instantáneo 24/7).';
  return 'Not allowed currency';
};

export const country = (currency) => {
  if (currency == 'usd') return 'Estados Unidos';
  if (currency == 'eur') return 'Europa';
  if (currency == 'mxn') return 'México';
  if (currency == 'brl') return 'Brasil';
  else return 'none';
};

export const paymentRail = (rail) => {
  if (rail == 'ach_push') return 'ACH_PUSH';
  if (rail == 'wire') return 'WIRE';
  if (rail == 'sepa') return 'SEPA';
  if (rail == 'swift') return 'SWIFT';
  if (rail == 'spei') return 'SPEI';
  if (rail == 'pix') return 'PIX';
  return 'Not allowed payment rail';
};

export const getEstimatedTime = (currency, transferMethod) => {
  if (currency == 'usd') {
    if (transferMethod == 'ACH_PUSH') return ' 1 a 3 días hábiles';
    if (transferMethod == 'WIRE')
      return 'Las transferencias WIRE recibidas antes de las 14:00 EST generalmente se acreditan el mismo día hábil.';
    return 'Not allowed transfer method';
  }
  if (currency == 'eur') return 'Hasta 24hs ';
  if (currency == 'mxn') return 'Inmediato';
  if (currency == 'brl') return 'Inmediato';
  return 'Not allowed currency';
};

export const getAccountType = (currency) => {
  if (currency == 'usd') return 'us';
  if (currency == 'eur') return 'iban';
  if (currency == 'mxn') return 'clabe';
  if (currency == 'brl') return 'pix';
  return 'unknown';
};

export const getVACreationText = (currency) => {
  if (currency == 'usd') return 'EEEUU';
  if (currency == 'eur') return 'Europa';
  if (currency == 'mxn') return 'México';
  if (currency == 'brl') return 'Brasil';
  return 'Not allowed region or country';
};

export const emailValidator = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const capitalizeFirst = (str) => {
  return str[0].toUpperCase() + str.slice(1).toLowerCase();
};

export const GettingNativeAsset = (assetId) => {
  if (!assetId || typeof assetId !== 'string') return NativeAsset[0];

  const nativeIndex = NativeAsset.findIndex((native) =>
    assetId.split('_').includes(native.assetSymbol)
  );

  if (nativeIndex !== -1) {
    return NativeAsset[nativeIndex];
  }

  return NativeAsset[0];
};
